import { useEffect } from 'react';
import { Col, Row } from 'antd';
import DOMPurify from 'isomorphic-dompurify';

import classes from './terms.module.less';

const TermsContainerKpoinHb = (props:any) => {
	const content = props.contentConsent;
	useEffect(() => {
		window.scrollBy({
			top: 5,
			left: 0,
			behavior: 'smooth',
		});
	}, []);
	return (
		<div className={classes['page-body-wrap']}>
			<div className={`container ${classes['wrap-container']}`}>
				<div className={classes['wrap-content']}>
					<Row gutter={0}>
						<Col sm={{ span: 24 }} xs={{ span: 24 }}>
							<div
								className={classes['paragraph-content']}
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(content.consent_content),
								}}
							/>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default TermsContainerKpoinHb;
